module.exports = __webpack_public_path__ + "media/images/topics/ebooks_cover-02036527857895feabaaccd565a90ca1.svg";